/* WorkTriggerPlanTargetsReadonlyTabComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./WorkTriggerPlanTargetsReadonlyTabRenderer");
const DateComponent = require("./column_renderers/date/DateComponent");
const PagingPlanFeed = require("./PagingPlanFeed");

class WorkTriggerTargetsReadonlyTabComponent extends EventEmitter {
    constructor(workTriggerDetailsView) {
        super();
        this._workTriggerDetailsView = workTriggerDetailsView;
        this._workTriggerDetailsView._targetViewOpen = true;
        this._gameEditor = workTriggerDetailsView.getGameEditor();

        const workTarget = this._workTriggerDetailsView._triggerType.getWorkTarget();
        this._gridKey = "plan_schedule_targets";
        const filter = { id: { $in: workTarget.ids } };
        this._pagingFeed = new PagingPlanFeed({
            feedKey: this._gridKey + "_feed",
            userSession: this.gameEditor.getUserSession(),
            entityDef: this._workTriggerDetailsView.getOSUpgradePlanEntityClass(),
            columnConfig: this.columnConfig,
            sort: { name: 1 },
            pageSize: 100,
            filter
        });

        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._workTriggerDetailsView.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._workTriggerDetailsView.on("WorkTypeChanged", (this._onWorkTypeChanged = this._onWorkTypeChanged.bind(this)));
    }

    _unregisterListeners() {
        this._workTriggerDetailsView.removeListener("Shutdown", this._onShutdown);
        this._workTriggerDetailsView.removeListener("WorkTypeChanged", this._onWorkTypeChanged);
    }

    shutdown() {
        return Promise.all([])
            .then(() => {
                this.emit("Shutdown");
                this._unregisterListeners();
                this._workTriggerDetailsView._targetViewOpen = undefined;
                this._workTriggerDetailsView = undefined;
            })
            .catch((err) => {
                this.logger.warn({ error: err }, "WorkTriggerTargetsReadonlyTabComponent.shutdown() error");
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get workTriggerDetailsView() {
        return this._workTriggerDetailsView;
    }

    get logger() {
        return this._workTriggerDetailsView._logger;
    }

    get workTarget() {
        return this.getWorkTarget();
    }
    getWorkTarget() {
        return this._workTriggerDetailsView.getWorkTarget();
    }
    set workTarget(t) {
        return this.setWorkTarget(t);
    }
    setWorkTarget(t) {
        return this._workTriggerDetailsView.setWorkTarget(t);
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    set pagingFeed(newPagingFeed) {
        this._pagingFeed = newPagingFeed;
    }
    get pagingFeed() {
        return this._pagingFeed;
    }

    get columnConfig() {
        return {
            action: {
                label: "Action",
                width: 80,
                priority: 10
            },
            name: {
                label: "Name",
                width: 220,
                priority: 20
            },
            description: {
                label: "Description",
                width: 300,
                priority: 30
            },
            deviceCount: {
                label: "Total Devices",
                width: 110,
                priority: 40
            },
            createdBy: {
                label: "Created By",
                width: 120,
                priority: 60
            },
            createdOn: {
                label: "Created On",
                width: 160,
                priority: 70,
                columnRendererComponent: DateComponent,
                updateFromEntity: true
            },
            updatedBy: {
                label: "Updated By",
                width: 120,
                priority: 80
            },
            updatedOn: {
                label: "Updated On",
                width: 160,
                priority: 90,
                columnRendererComponent: DateComponent
            },
            siteCodeName: {
                label: "Site Code Name",
                entityColumn: "siteCodeName",
                width: 80
            }
        };
    }

    _getOsPlanDataForAdvancedFilter(data) {
        let clonedData = _.clone(data);
        let newObj = {};
        for (let key in clonedData) {
            let value = {};
            value[key] = {
                name: key,
                title: clonedData[key]
            };
            newObj = Object.assign(newObj, value);
        }
        return newObj;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onShutdown() {
        this.shutdown();
    }

    _onWorkTypeChanged(newWorkType, oldWorkType) {
        if (newWorkType.targetConstruct !== oldWorkType.targetConstruct || newWorkType.targetEntityType !== oldWorkType.targetEntityType) {
            //
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /*******************************************/
}
module.exports = WorkTriggerTargetsReadonlyTabComponent;
